import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseUnits, parseEther } from "viem";
import chinaAbi from "../../utils/chinaAbi.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";
import { contractIsSpecialCodeArg } from "../../utils/specialUser";

const usePurchaseUsdc = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const UsdcAddress = Environment.usdc;

  const purchaseUsdc = useCallback(
    async (amount, postApiRes, id, balance, min, stakeIndex, index, insurancePer) => {
      if (!isConnected || !account) throw new Error("WALLET_NOT_CONNECTED");

      let nd;
      if (index) {
        let percent = parseFloat(amount) * insurancePer;
        let value = parseFloat(amount) + percent;
        let rounded = Math.round(parseFloat(value).toFixed(6) * 1e12) / 1e12;
        nd = parseUnits(rounded.toString(), 6);
      } else {
        let rounded = Math.round(parseFloat(amount).toFixed(6) * 1e12) / 1e12;
        nd = parseUnits(rounded.toString(), 6);
      }

      let minvalue = Math.round((parseFloat(min) * 0.99).toFixed(6) * 1e12) / 1e12;
      minvalue = parseEther(minvalue.toString());

      try {
        const hash = await writeContractAsync({
          address: Environment.presaleContract,
          abi: chinaAbi,
          functionName: "purchaseTokenWithToken",
          args: [
            UsdcAddress,
            postApiRes?.normalizationFactor,
            postApiRes?.price,
            nd,
            minvalue,
            postApiRes?.agentsAddresses,
            postApiRes?.agentsPercentages,
            postApiRes.code,
            id,
            postApiRes.deadline,
            contractIsSpecialCodeArg(postApiRes),
            postApiRes?.v,
            postApiRes?.r,
            postApiRes?.s,
          ],
        });

        console.log("USDC tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        console.log("USDC purchase confirmed:", receipt);

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("USDC purchase error:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync]
  );

  return { purchaseUsdc };
};

export default usePurchaseUsdc;
